import { useEffect, useMemo, useState } from "react";
import prepareForOptions from "~services/utils/prepareForOptions";
import { db } from "~/db/db";

const useGrupoProdutoV2 = ({
  filial,
  filiais,
  filiaisDisponiveis,
  gruposPorFamilia,
  camposOpt = ["codigo", "nome"],
  gruposDisponiveis,
  replicacao = false,
}) => {
  const [gruposProduto, setGruposProduto] = useState([]);

  const getMateriaisForFilial = (key, filiaisDisponiveisObj) => {
    const materiais = filiaisDisponiveisObj["key-" + key]?.materiais;
    return Array.isArray(materiais) && materiais.length > 0 ? materiais.map((e) => parseInt(e)) : [];
  };

  const applyMateriaisToQuery = (query, materiais, wheres) => {
    if (materiais.length > 0) {
      if (wheres > 0) {
        return { query: query.and((a) => materiais.includes(a.id)), wheres: wheres + 1 };
      }
      return { query: query.where("id").anyOf(materiais), wheres: wheres + 1 };
    }
    return { query, wheres };
  };

  useEffect(() => {
    const fetchGruposProduto = async (signal) => {
      let query = db.grupoProdutos;
      let wheres = 0;

      let materiais = [];
      if (filial && filiaisDisponiveis) {
        materiais = getMateriaisForFilial(filial, filiaisDisponiveis);
        ({ query, wheres } = applyMateriaisToQuery(query, materiais, wheres));
      }

      if (Array.isArray(filiais) && filiais.length > 0 && filiaisDisponiveis) {
        let materiaisArray = [];
        filiais.forEach((f) => {
          materiaisArray = materiaisArray.concat(getMateriaisForFilial(f.id, filiaisDisponiveis));
        });
        ({ query, wheres } = applyMateriaisToQuery(query, materiaisArray, wheres));
      }

      if (gruposDisponiveis) {
        if (wheres > 0) {
          query = query.and((a) => gruposDisponiveis.includes(a.id));
        } else {
          query = query.where("id").anyOf(gruposDisponiveis);
        }
      }

      if (Array.isArray(gruposPorFamilia) && gruposPorFamilia.length > 0) {
        if (wheres > 0) {
          query = query.and((a) => gruposPorFamilia.includes(a.id));
        } else {
          query = query.where("id").anyOf(gruposPorFamilia);
        }
      }

      if (replicacao) {
        query = query.filter((a) => a.replicacaoAtiva !== false);
      }

      const result = [];
      await query.filter((a) => a.ativo).each((item) => result.push(item));

      if (!signal.aborted) {
        setGruposProduto(result);
      }
    };

    const controller = new AbortController();
    const { signal } = controller;

    fetchGruposProduto(signal);

    return () => {
      controller.abort();
    };
  }, [filial, filiais, filiaisDisponiveis, gruposPorFamilia, gruposDisponiveis, replicacao]);

  const optionGruposProduto = useMemo(
    () =>
      prepareForOptions(
        (gruposProduto || []).sort((a, b) => a.nome.localeCompare(b.nome)),
        camposOpt,
        "id"
      ),
    [gruposProduto, camposOpt]
  );

  return {
    gruposProduto,
    optionGruposProduto,
  };
};

export default useGrupoProdutoV2;
